function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  d: "M38.1 19.55a18.55 18.55 0 11-37.1 0 18.55 18.55 0 0137.1 0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  d: "M14.84 1.6v0s3.1 4.5 2.1 6.74-3.01 1.82-3.74 2.24c-.72.42-5.14.83-3.78 2.19 1.36 1.36 3.72 1.48 5.28 3.04 1.55 1.56.89 3.73 2.44 3.73s2.63-2.96 4.1-1.48c1.5 1.48-.82 5.22-2.68 7.09-1.87 1.86-.22 3.01-1.06 3.85-.84.85-2.06 1.62-2.06 3.24s-3.73 3.24-4.23.5c-.5-2.74.81-6.79-.37-7.97-1.18-1.18-3.36-4.14-2.5-6.86.88-2.72-5.17-7.07-5.17-7.07v0M37.52 14.96v0s-4.94.15-6.52-.76c-1.58-.91-4.98 1-4.36 4.48.63 3.48 3.32 1.52 5.4 3.6 2.1 2.1-1.09 4.39 0 5.49 1.1 1.1 1.79 2.2.75 4.77M27.08 2.6v0s-4.17 3.63-3.3 5.5c.87 1.86 1.96 1.23 3.3.46 1.34-.77 1.54-1.65 3.05-.77 1.5.87 4.16.51 4.16.51v0"
});

var SvgEarth = function SvgEarth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEarth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/earth.333cb6aa.svg";
export { ForwardRef as ReactComponent };